import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateSubjectTypeDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code du type de matière' })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Libellé du type de matière' })
  @IsOptional()
  @IsString()
  label?: string
}
